import { WarehouseRow } from "./WarehouseRow";
import { AisleRow } from "./AisleRow";
import { Position, Shelf } from "./styles";

interface Props {
    warehouseKey: string;
    warehouse: any;
}

export const WarehouseTable = ({ warehouseKey, warehouse }: Props) => {

    return (
        <Position key={warehouseKey}>
            <Shelf>{warehouseKey.replace('D', 'ASMAT').replace('J', 'JAMS')}</Shelf>
            <table>
                <tbody>
                    <tr>
                        <td>Magazyn</td>
                        <td>Zajęte / Wszystkie (%)</td>
                        <td>Wolne (%)</td>
                    </tr>
                    <WarehouseRow warehouseKey={warehouseKey} warehouse={warehouse} />
                    <tr>
                        <td>Alejka</td>
                        <td>Zajęte / Wszystkie (%)</td>
                        <td>Wolne (%)</td>
                    </tr>
                    {Object.entries(warehouse.aisles).map(([aisleKey, aisle]: [string, any]) =>
                        <AisleRow key={aisleKey} aisleKey={aisleKey} aisle={aisle} />
                    )}
                </tbody>
            </table>
        </Position>
    );
}